import { STATIONS_CFG } from '../config/measConfig'
import { calcFromTo, calcMonthFromTo } from './useGrafData'
import { getOffsetMs } from '../utils/timeUtils'

function pad2(n) {
  return String(n).padStart(2, '0')
}

// Klouzavé okno posledních 30 dní končící VČEREJŠKEM pro volbu "aktuální" — stejné jako
// calcAktualFromTo v DlyGrafView.jsx (1 stanice). Dnešní den se nekreslí.
function calcDlyAktualFromTo() {
  const now = new Date()
  const to = new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate() - 1))
  const from = new Date(to.getTime() - 30 * 86400000)
  const fmt = d => `${d.getUTCFullYear()}${pad2(d.getUTCMonth() + 1)}${pad2(d.getUTCDate())}2359`
  const fmtFrom = d => `${d.getUTCFullYear()}${pad2(d.getUTCMonth() + 1)}${pad2(d.getUTCDate())}0000`
  return { from: fmtFrom(from), to: fmt(to) }
}

// Vrátí URL pro /chart?type=stations endpoint — obdoba buildChartUrl z useGrafData.js, ale pro
// více stanic (stations= CSV) a s parametrem q (výběr veličiny z cfg=multi.quantities), viz
// doc/plans/station-group-meas.md sekce 5.
export function buildStationsChartUrl(baseUrl, ghIds, measDef, dateOrYearMonth, tz, format = 'png') {
  const type = 'stations'
  const tzParam = encodeURIComponent(tz)
  // format = null/'' → nepřidávej &format (volající si ho doplní, viz ChartFrame withJsonFormat)
  const fmtParam = format ? `&format=${encodeURIComponent(format)}` : ''
  const stationsParam = ghIds.join(',')
  const qParam = encodeURIComponent(measDef.q)
  const base = `${baseUrl}/chart?type=${type}&cfg=${STATIONS_CFG}&q=${qParam}&gran=${measDef.granKey}` +
    `&stations=${stationsParam}&timezone=${tzParam}${fmtParam}`

  // 10m — "aktuální" posílá minutes= (server: to = floor((now − 5 min)/10 min)*10 min — OK).
  if (measDef.granKey === '10m' && dateOrYearMonth.isAktual) {
    const minutes = dateOrYearMonth.windowDays * 1440
    return `${base}&minutes=${minutes},10`
  }
  // hly — minutes=,60 by serverovým zaokrouhlením (to = floor((now − 30 min)/60 min)*60 min)
  // schovalo prvních 30 min každé hodiny už dostupnou předchozí hodinu. Pošleme from/to s koncem
  // na poslední dokončené hodině (viz buildChartUrl v useGrafData.js).
  if (measDef.granKey === 'hly' && dateOrYearMonth.isAktual) {
    const stepMs = 60 * 60_000
    const toMs = Math.floor(Date.now() / stepMs) * stepMs
    const fromMs = toMs - dateOrYearMonth.windowDays * 1440 * 60_000
    const fmtLocal = ms => {
      const l = new Date(ms + getOffsetMs(new Date(ms), tz))
      return `${l.getUTCFullYear()}${pad2(l.getUTCMonth() + 1)}${pad2(l.getUTCDate())}${pad2(l.getUTCHours())}${pad2(l.getUTCMinutes())}`
    }
    return `${base}&from=${fmtLocal(fromMs)}&to=${fmtLocal(toMs)}`
  }

  // dly — stejně jako DlyGrafView: "aktuální" = klouzavé okno posledních 30 dní
  if (measDef.granKey === 'dly' && dateOrYearMonth.isAktual) {
    const { from, to } = calcDlyAktualFromTo()
    return `${base}&from=${from}&to=${to}`
  }

  const { from, to } = calcMeasFromTo(measDef.granKey, dateOrYearMonth)
  return `${base}&from=${from}&to=${to}`
}

// from/to podle granularity — 10m/hly: den (dateOrYearMonth = 'YYYY-MM-DD'), dly: celý měsíc
// (dateOrYearMonth = { year, month }).
export function calcMeasFromTo(granKey, dateOrYearMonth) {
  if (granKey === 'dly') {
    const { year, month } = dateOrYearMonth
    return calcMonthFromTo(year, month)
  }
  if (granKey === 'hly') {
    const { dateStr, windowDays, alignEnd } = dateOrYearMonth
    return calcFromTo(dateStr, windowDays, alignEnd)
  }
  // 10m — okno více dní, stejně jako GrafView (windowDays/alignEnd)
  const { dateStr, windowDays, alignEnd } = dateOrYearMonth
  return calcFromTo(dateStr, windowDays, alignEnd)
}
